import styled from "styled-components";

export const StyledSliderWrapper = styled.div`
  width: 100%;
  position: relative;
  background: #fafbfc;
  border-radius: 16px;
  border: 2px solid #7db7fa;
  padding: 32px 16px 24px 16px;
  margin-bottom: 24px;
`;

export const CustomTooltip = styled.div<{
  left: number;
  color: string;
  disabled: boolean;
}>`
  position: absolute;
  top: -4px;
  left: ${({ left }) => left}px;
  transform: translateX(-50%);
  background: ${({ color }) => color};
  color: #fff;
  padding: 2px 14px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 400;
  display: flex;
  align-items: center;
  gap: 8px;
  z-index: 10;
  white-space: nowrap;
  opacity: ${({ disabled }) => (disabled ? 0.7 : 1)};
  &::after {
    content: "";
    position: absolute;
    left: 50%;
    bottom: -8px;
    transform: translateX(-50%);
    border-width: 8px 8px 0 8px;
    border-style: solid;
    border-color: ${({ color }) => color} transparent transparent transparent;
  }
`;

export const ColoredSliderWrapper = styled.div<{ color: string }>`
  .ant-slider-track {
    background-color: ${({ color }) => color} !important;
  }

  .ant-slider-handle {
    border-color: ${({ color }) => color} !important;
    background-color: ${({ color }) => color} !important;
    box-shadow: 0 0 0 2px ${({ color }) => color}22;
  }

  .ant-slider-rail {
    background-color: ${({ color }) => color} !important;
    opacity: 0.3;
  }

  .ant-slider-dot {
    display: none !important;
  }

  .ant-slider-disabled {
    opacity: 0.7;
  }
`;

export const MarkWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;

  div {
    width: 2px;
    height: 6px;
    background-color: #000000;
    border-radius: 1px;
    opacity: 0.2;
  }

  span {
    font-size: 12px;
    font-weight: 400;
    font-family: "Inter", sans-serif;
    opacity: 0.2;
    color: #000000;
  }
`;

export const StatusPopover = styled.div`
  width: 100%;

  .status_title {
    font-size: 16px;
    font-weight: 500;
    color: #0f172a;
    font-family: "Inter";
    margin-bottom: 20px;
  }

  .status_subtitle {
    font-size: 13px;
    font-weight: 400;
    color: #475569;
    font-family: "Inter";
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
  }

  .status_buttons {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;

    button {
      border-radius: 8px;
      padding: 8px 10px;
      width: 100%;
      font-size: 13px;
      font-weight: 500;
      color: #475569;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      border: 1px solid #e2e8f0;
      background-color: #fff;
    }

    button:disabled {
      opacity: 0.7;
      cursor: not-allowed;
    }

    button:nth-child(1) {
      &:hover {
        background-color: rgba(234, 179, 8, 0.14);
        border: 1px solid rgba(234, 179, 8, 0.14);
      }
    }

    button:nth-child(2) {
      &:hover {
        background-color: rgba(239, 68, 68, 0.14);
        border: 1px solid rgba(239, 68, 68, 0.14);
      }
    }
  }
`;
